import React from 'react';
import PropTypes from 'prop-types';

const ComboboxFooter = ({ children }) => (
  <div className="combobox__footer" role="presentation">
    {children}
  </div>
);

ComboboxFooter.propTypes = {
  children: PropTypes.node,
};

export default ComboboxFooter;
